import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/campaignAds.ts
/**
* Mirror of the GraphQL `CampaignMediaType` enum. Kept inline so the
* contract package stays free of server-side generated codegen imports;
* the canonical definition lives in the GraphQL schema and is regenerated
* into `generated/graphql.ts` on the server.
*/
const campaignMediaTypeSchema = z.enum([
	"IMAGE",
	"VIDEO",
	"VIDEO_HLS",
	"VIDEO_STREAM"
]);
const campaignEntrySchema = z.object({
	title: z.string().optional(),
	description: z.string().optional(),
	trackingId: z.string().optional(),
	type: campaignMediaTypeSchema,
	media: z.string(),
	targetUrl: z.string().optional(),
	position: z.number().int().optional(),
	isShownForYearlyMember: z.boolean(),
	isShownForMonthlyMember: z.boolean(),
	isAd: z.boolean(),
	isClickableForNonLoginUser: z.boolean()
});
const listCampaignAdsInputSchema = z.object({
	language: z.string().min(1).max(20).optional(),
	category: z.string().min(1).max(50).optional()
});
const listCampaignAdsOutputSchema = z.object({ data: z.array(campaignEntrySchema) });
const campaignAdsContract = oc.prefix("/campaign-ads").tag("CampaignAds").router({ list: oc.route({
	summary: "List campaign ads for a language and category",
	description: "Returns the campaign banner / ad entries configured for the given category, falling back to English if the requested language is not present in the YAML config.",
	method: "GET",
	path: "/"
}).input(listCampaignAdsInputSchema).output(listCampaignAdsOutputSchema) });
//#endregion
export { campaignAdsContract, campaignEntrySchema, listCampaignAdsInputSchema, listCampaignAdsOutputSchema };
